import React from "react";
import OrderConsole from "../components/orders/OrderConsole";

const Dashboard = () => {
  return <OrderConsole />;
};

export default Dashboard;
